import classes from './Nav.module.css'
interface NavProps{
    changeActive: (value: String)=>void,
    active: String,
    totalAccept: string | number,
    totalReject: string | number,
    totalSend: string | number
}

const Nav: React.FC<NavProps> = ({changeActive, active, totalAccept, totalReject, totalSend})=>(
   
          <div className={classes.headNav}>
              <div onClick={()=>changeActive('first')} className={active === 'first' ? [classes.NavEl, classes.first, classes.active].join(' ') : [classes.NavEl, classes.first].join(' ')}>
                  <p className={classes.number}>({totalSend})</p>
                  <p className={classes.navLabel}>المتقدمين</p>
              </div>
              <div 
                onClick={()=>changeActive('center')} 
                className={active === 'center' ? [classes.NavEl, classes.center, classes.active].join(' ') : [classes.NavEl, classes.center].join(' ')}>
                <p className={classes.number}>({totalReject})</p>
                <p className={classes.navLabel}>المرفوض</p>
              </div>
              <div 
                onClick={()=>changeActive('last')}  
                className={active === 'last' ? [classes.NavEl, classes.last, classes.active].join(' ') : [classes.NavEl, classes.last].join(' ')}>
                <p className={classes.number}>({totalAccept})</p>
                <p className={classes.navLabel}>مقابلة شخصية</p>
              </div>
          </div>
)


export default Nav